import { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Collapse,
  Button,
  Loading,
  Paper,
  Tabs,
  Tab,
  TabPanel,
  Grid,
  Select,
  MenuItem,
  TextareaAutosize,
  Divider,
  MultiImageMedia,
  Tooltip,
} from "../../../../components";

const ChecklistOrdemServico = ({
  ordemServicoEntity,
  ordemServico,
  setOrdemServico,
  acessoriosAtivo,
  setAcessoriosAtivo,
  locaisAvaria,
  setLocaisAvaria,
  tiposAvaria,
  avariaSelecionada,
  setAvariaSelecionada,
  isFechado,
  somenteLeitura,
  loading,
  handleChangeInput,
  onImprimirTermoAceite,
  permiteImprimirTermoAceite,
}) => {
  const [abaValue, setAbaValue] = useState(0);
  const [openChecklistCollapsed, setOpenChecklistCollapsed] = useState(false);
  const bloquearEdicao = isFechado || somenteLeitura;
  const semFotos = !ordemServico?.imagens?.length;

  useEffect(() => {
    sincronizarChecklistNaEntidade(acessoriosAtivo, locaisAvaria);
  }, [acessoriosAtivo, locaisAvaria]);

  const tabProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  const sincronizarChecklistNaEntidade = (acessorios, locais) => {
    if (!ordemServicoEntity?.setChecklist || !setOrdemServico) {
      return;
    }

    const acessoriosPayload = (acessorios || []).map((acessorio) => ({
      acessorioId: acessorio.id,
      contem: !!acessorio.contem,
    }));

    const avariasPayload = [];
    (locais || []).forEach((local) => {
      (local.componentes || []).forEach((componente) => {
        if (componente.tipoId) {
          avariasPayload.push({
            localId: local.id,
            componenteId: componente.id,
            tipoId: componente.tipoId,
          });
        }
      });
    });
    ordemServicoEntity?.setChecklist(acessoriosPayload, avariasPayload);
    setOrdemServico({ ...ordemServicoEntity });
  };

  return (
    <>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Paper
          onClick={() => setOpenChecklistCollapsed((prev) => !prev)}
          role="button"
          aria-expanded={openChecklistCollapsed}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.5,
            borderRadius: 2,
            border: "1px solid",
            borderColor: openChecklistCollapsed ? "primary.main" : "#dfe3e8",
            backgroundColor: openChecklistCollapsed
              ? "rgba(25, 118, 210, 0.08)"
              : "#f8fafc",
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
              borderColor: "primary.main",
              backgroundColor: "rgba(25, 118, 210, 0.12)",
            },
          }}
        >
          <Box>
            <Typography variant="h6">Checklist da Ordem de Serviço</Typography>
            <Typography variant="caption" color="textSecondary">
              {openChecklistCollapsed
                ? "Clique para recolher"
                : "Clique para expandir"}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {permiteImprimirTermoAceite && (
              <Tooltip
                title="Imprimir Termo de Aceite do Checklist"
                arrow
                placement="left"
              >
                <Box
                  role="button"
                  aria-label="Imprimir Termo de Aceite do Checklist"
                  onClick={(e) => {
                    e.stopPropagation();
                    onImprimirTermoAceite();
                  }}
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid",
                    borderColor: openChecklistCollapsed
                      ? "primary.main"
                      : "#d1d9e6",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      borderColor: "primary.main",
                      backgroundColor: "rgba(25, 118, 210, 0.08)",
                    },
                  }}
                >
                  <i
                    className="ph-fill ph-printer"
                    style={{ fontSize: 16, color: "#1976d2" }}
                  />
                </Box>
              </Tooltip>
            )}
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid",
                borderColor: openChecklistCollapsed ? "primary.main" : "#d1d9e6",
                backgroundColor: "#fff",
                transition: "all 0.2s ease",
              }}
            >
              <i
                className="ph-fill ph-caret-down"
                style={{
                  fontSize: 16,
                  color: "#1976d2",
                  transform: openChecklistCollapsed
                    ? "rotate(0deg)"
                    : "rotate(-90deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
      <Collapse in={openChecklistCollapsed} timeout="auto" unmountOnExit>
        <Paper className="mt-3">
          <Tabs
            value={abaValue}
            onChange={(e, newValue) => setAbaValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="ACESSÓRIOS DO ATIVO" {...tabProps(0)} />
            <Tab label="AVARIAS DO ATIVO" {...tabProps(1)} />
            <Tab label="OBSERVAÇÕES" {...tabProps(2)} />
            <Tab label="FOTOS" {...tabProps(3)} />
          </Tabs>
        </Paper>
        <TabPanel value={abaValue} index={0}>
          <Box sx={{ p: 2 }}>
            {acessoriosAtivo.length === 0 && (
              <Typography variant="body2" color="textSecondary">
                Nenhum acessório cadastrado para este ativo.
              </Typography>
            )}
            <Grid container spacing={2}>
              {acessoriosAtivo.length > 0 &&
                acessoriosAtivo.map((acessorio, i) => (
                  <Grid item xs={6} key={acessorio.id}>
                    <Box
                      className="d-flex align-items-center justify-content-between px-3 py-2 rounded"
                      style={{
                        border: "1px solid #eeeeee",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          fontSize: 13,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          flex: 1,
                        }}
                      >
                        {acessorio.descricao}
                      </Typography>
                      <Box className="d-flex gap-1 ms-2">
                        <Button
                          variant={acessorio?.contem ? "contained" : "outlined"}
                          disableElevation
                          size="small"
                          color="primary"
                          disabled={bloquearEdicao}
                          onClick={() => {
                            setAcessoriosAtivo((prev) =>
                              prev.map((acessorio, index) =>
                                index === i
                                  ? { ...acessorio, contem: true }
                                  : acessorio,
                              ),
                            );
                          }}
                        >
                          SIM
                        </Button>
                        <Button
                          variant={acessorio?.contem ? "outlined" : "contained"}
                          size="small"
                          disableElevation
                          color="error"
                          disabled={bloquearEdicao}
                          onClick={() => {
                            setAcessoriosAtivo((prev) =>
                              prev.map((acessorio, index) =>
                                index === i
                                  ? { ...acessorio, contem: false }
                                  : acessorio,
                              ),
                            );
                          }}
                        >
                          NÃO
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </TabPanel>
        <TabPanel value={abaValue} index={1}>
          <Box sx={{ p: 2 }}>
            {locaisAvaria.length === 0 && (
              <Typography variant="body2" color="textSecondary">
                Nenhuma avaria cadastrada para este ativo.
              </Typography>
            )}
            <Grid container spacing={2} className="mb-3">
              {locaisAvaria.length > 0 &&
                locaisAvaria.map((local, i) => (
                  <Grid item xs={1.5} key={`local-avaria-${i}`}>
                    <Button
                      variant={
                        avariaSelecionada === i ? "contained" : "outlined"
                      }
                      fullWidth
                      disableElevation
                      size="small"
                      onClick={() => setAvariaSelecionada(i)}
                    >
                      {local.descricao}
                    </Button>
                  </Grid>
                ))}
            </Grid>
            {avariaSelecionada !== null &&
              locaisAvaria[avariaSelecionada] &&
              locaisAvaria[avariaSelecionada].componentes.map((componente) => (
                <Box
                  key={componente.id}
                  className="d-flex align-items-center mb-2 p-2 ps-3 rounded-3"
                  style={{ border: "1px solid #eeeeee" }}
                >
                  <Typography
                    variant="body2"
                    className="d-flex"
                    sx={{
                      width: "70%",
                    }}
                  >
                    {componente.descricao}
                    {componente.obrigatoriedade && (
                      <Typography
                        component="span"
                        color="error"
                        sx={{ ml: 0.5 }}
                      >
                        *
                      </Typography>
                    )}
                  </Typography>
                  <Select
                    fullWidth
                    name="tipoId"
                    id="tipoId"
                    variant="outlined"
                    size="small"
                    sx={{ width: "30%" }}
                    value={componente.tipoId ?? ""}
                    disabled={bloquearEdicao}
                    onChange={(e) => {
                      setLocaisAvaria((prev) =>
                        prev.map((local) =>
                          local.id === locaisAvaria[avariaSelecionada].id
                            ? {
                                ...local,
                                componentes: local.componentes.map((comp) =>
                                  comp.id === componente.id
                                    ? {
                                        ...comp,
                                        tipoId: e.target.value,
                                      }
                                    : comp,
                                ),
                              }
                            : local,
                        ),
                      );
                    }}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    {tiposAvaria.map((tipo) => (
                      <MenuItem key={tipo.id} value={tipo.id}>
                        {tipo.descricao}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              ))}
          </Box>
        </TabPanel>
        <TabPanel value={abaValue} index={2}>
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
              Observações adicionais sobre o checklist (opcional)
            </Typography>
            <TextareaAutosize
              id="observacoesChecklist"
              name="observacoesChecklist"
              className="textRolagem bg-transparent"
              label="Observações do checklist"
              maxLength={550}
              disabled={bloquearEdicao}
              value={ordemServico?.observacoesChecklist}
              onChange={handleChangeInput}
            />
          </Box>
        </TabPanel>
        <TabPanel value={abaValue} index={3}>
          <Box sx={{ p: 2, mt: 2 }}>
            {semFotos && bloquearEdicao ? (
              <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
                Sem fotos cadastradas.
              </Typography>
            ) : (
              <MultiImageMedia
                useValue={ordemServico}
                setUseValue={setOrdemServico}
                entity={ordemServicoEntity}
                maxImages={15}
                viewMode="sequence"
                disabled={bloquearEdicao}
              />
            )}
          </Box>
        </TabPanel>
        <Divider sx={{ my: 2, border: "1px solid grey", width: "100%" }} />
      </Collapse>
      <Loading loading={loading} />
    </>
  );
};

export default ChecklistOrdemServico;
